import React from 'react';

import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { useHistory } from 'react-router-dom';

import { useI18n } from 'Hooks';

import { Wrapper } from './styles';
import { Heading } from '../Typography/Heading';

export interface Props {
  text?: string;
  showBackIcon?: boolean;
  handleClick?: () => void;
}

const BackButton = ({ text, handleClick }: Props) => {
  const history = useHistory();
  const { t } = useI18n();

  const onClick = () => {
    if (handleClick) handleClick();
    history.goBack();
  };

  return (
    <Wrapper onClick={onClick}>
      <ArrowBackIcon htmlColor="var(--colorUIBlack)" />
      <Heading level={5} color="var(--colorUIBlack)" bottom={0}>
        {text || t('General.Back')}
      </Heading>
    </Wrapper>
  );
};

export default BackButton;
